import React, { useState, useEffect, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { FormatAmount } from '../FormatAmount';
import {
  Card,
  CardHeader,
  CardContent,
  Collapse,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const InvoiceProcessingdays = ({ filter, fetchedData, data, setLoading }) => {
    const [ListPayable, setListPayable] = useState([])
    const [pendingDaysData, setPendingDaysData] = useState([]);
    const [expanded, setExpanded] = useState(false); // for collapsible card

  const filterRef = useRef({ month: "", year: "",startDate:"",endDate:"" });
  //   useEffect(() => {
  //       if(fetchedData){
  // fetchData();
  //       }
  //   }, [fetchedData]);

  useEffect(() => {
    const newVals = { month: filter?.month ?? "", year: filter?.year ?? "",startDate:filter?.startDate?? "",endDate:filter?.endDate?? "" };
    filterRef.current = newVals; // update ref whenever filter changes
  }, [filter]);

    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardAOverviewIPDays?Month=${filter?.month}&Year=${filter?.year}`, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    //             },

    //         })
    //         console.log("response", response?.data?.response);
    //         setListPayable(response?.data?.response)
    //         setPendingDaysData("") // clear pending days data on main data fetch
    //     } catch (error) {
    //         console.log("error", error);
    //     }
    // }
      // mapping categories -> role codes

      const fixSequence = (data) => {
  const requiredOrder = [
    "Invoice Receiver",
    "Tax Team",
    "Invoice Processor",
    "Department Coordinator",
    "LOAM Approver",
    "Buyer",
    "AP Supervisor",
    "Overall Average By I2P"
  ];

  const normalizeName = {
    "Invoice reciever": "Invoice Receiver",
    "Invoice Receiver": "Invoice Receiver",

    "Tax team": "Tax Team",
    "Tax Team": "Tax Team",

    "Department Cordinator": "Department Coordinator",
    "Department Coordinator": "Department Coordinator",

    "Invoice Processor": "Invoice Processor",

    "Buyer": "Buyer",

    "AP Supervisor": "AP Supervisor",

    "Loam Approver": "LOAM Approver",
    "LOAM Approver": "LOAM Approver",

    "Overall I2P": "Overall Average By I2P",
    "Overall Average By I2P": "Overall Average By I2P"
  };

  // 1. Normalize all API names
  const normalized = data.map(item => ({
    ...item,
    name: normalizeName[item.name.trim()] || item.name.trim()
  }));

  // 2. Sort according to required order
  const sorted = requiredOrder.map(role =>
    normalized.find(item => item.name === role) || {
      name: role, today: 0, mtd: 0, ytd: 0
    }
  );

  return sorted;
};

useEffect(() => {
  if (data) {
    const fixed = fixSequence(data);
    setListPayable(fixed);
        setPendingDaysData(""); // clear pending days data on main data update
  }
}, [data]);

  const roleMapping = {
    "Invoice Receiver": "IR",
    "Tax Team": "TaxTeam",
    "Invoice Processor": "IP",
    "Department Coordinator": "Department Coordinator",
    "LOAM approver": "Loam Approver",
    "Buyer": "Buyer",
    "AP Supervisor": "AP Supervisor",
    "Overall Average By I2P": "OA",
  };

  const categories = Object.keys(roleMapping);

    const seriesData = [{
        name: 'MTD',
        data: ListPayable.map((item, index) => {
            return item?.mtd
        })
    }, {
        name: 'YTD',
        data: ListPayable.map((item, index) => {
            return item?.ytd
        })
    }, {
        name: 'Today',
        data: ListPayable.map((item, index) => {
            return item?.today
        })
    },
    ];

  // new API call on category click - unchanged, except we accept month/year params
  const handleXAxisLabelClick = async (event, chartContext, config, month, year,startDate,endDate) => {
    const categoryIndex = config.labelIndex;
    const categoryName = categories[categoryIndex];
    const roleCode = roleMapping[categoryName];

    console.log("Filter values in click handler:", { month, year, roleCode });

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Dashboard/GetIPPendingDaysByUser?fromDate=${startDate}&toDate=${endDate}&Role=${roleCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
       setLoading(false);
      setPendingDaysData(response?.data?.response || []);
      setExpanded(true); // open the card when data loads
    } catch (error) {
      setLoading(false);
      console.log("error fetching pending days", error);
    }
  };

  const options = {
    chart: {
      type: 'bar',
      height: 100,
      stacked: true,
      toolbar: { show: false },
      events: {
        xAxisLabelClick: (event, chartContext, config) => {
          // read current values from the ref (latest filter)
          const { month, year,startDate,endDate } = filterRef.current;
          handleXAxisLabelClick(event, chartContext, config, month, year,startDate,endDate);
        }
      },
    },
    plotOptions: { bar: { horizontal: true } },
    xaxis: {
      categories: categories,
      labels: { style: { cursor: 'pointer' } },
    },
    legend: { position: 'top' },
    fill: { opacity: 1 },
    };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

    return (
        <div id="horizontal-chart" style={{width:"inherit"}}>
            <ReactApexChart options={options} series={seriesData} type="bar" height={350} />
            <TableContainer style={{ marginTop: "2%",width:"100%",overflow:"scroll" }}>
            <Table style={{ marginTop: "2%"}}>
                <TableHead >
                    <TableRow sx={{ backgroundColor: "#EFF2F4", }}>
                        <TableCell style={{ color: "black", fontWeight: "bold" }}></TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Invoice Receiver</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Tax Team</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Invoice Processor</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Department Coordinator</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">LOAM Approver</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Buyer</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">AP Supervisor</TableCell>
                        <TableCell style={{ color: "black", fontWeight: "bold" }} align="right">Overall ( average By I2P System)</TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell style={{ color: "black", fontWeight: "bold" }}>Today</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[0]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[1]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[2]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[3]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[4]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[5]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[6]?.today)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[7]?.today)}</TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell style={{ color: "black", fontWeight: "bold" }}>MTD</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[0]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[1]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[2]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[3]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[4]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[5]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[6]?.mtd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[7]?.mtd)}</TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell style={{ color: "black", fontWeight: "bold"  }}>YTD</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[0]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[1]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[2]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[3]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[4]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[5]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[6]?.ytd)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[7]?.ytd)}</TableCell>
                    </TableRow>
                        <TableRow >
                        <TableCell style={{ color: "black" , fontWeight: "bold" }}>SELECTED DATE DATA</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[0]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[1]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[2]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[3]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[4]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[5]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[6]?.total)}</TableCell>
                        <TableCell align='right' style={{ color: "black" }}>{FormatAmount(ListPayable[7]?.total)}</TableCell>
                    </TableRow>
                </TableHead>
            </Table>
            </TableContainer>
      {pendingDaysData.length > 0 && (
        <Card
          sx={{
            mt: 3,
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <CardHeader
            title="Overview of Invoice processing days by User"
            sx={{ backgroundColor: '#EFF2F4', fontWeight: 'bold' }}
            action={
              <IconButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                  }}
                />
              </IconButton>
            }
          />
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <TableContainer
                style={{
              maxHeight: "500px",   // limit height
              overflow: "auto",     // enables scroll both directions
                }}
              >
            <Table stickyHeader>  {/* keeps header visible when scrolling */}
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Today</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">MTD</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">YTD</TableCell>        
                <TableCell style={{ fontWeight: "bold" }} align="right">SELECTED DATE DATA</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Action Time Today</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Total Invoice Today</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Action Time Monthly</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Total Invoice Monthly</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Action Time Yearly</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">Total Invoice Yearly</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">TotalActionDay</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">FullDateWorkingDate</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">TotalCurrentInvoiceFull</TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="right">InvoiceWorkedOnFull</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pendingDaysData.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell style={{ fontWeight: "bold" }}>{row.actionPerformedBy}</TableCell>
                  <TableCell align="right">{FormatAmount(row.today)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.mtd)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.ytd)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.total)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.actionToday + row.actionOnCurrentDate)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.totalCurrentInvoice + row.invoiceWorkedOn)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.monthlyActionDay + row.actionOnCurrentDateMonthly)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.totalCurrentInvoiceMonthly + row.invoiceWorkedOnMonthly)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.yearlyActionDay + row.actionOnCurrentDateYearly)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.totalCurrentInvoiceYearly + row.invoiceWorkedOnYearly)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.totalActionDay)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.fullDateWorkingDate)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.totalCurrentInvoiceFull)}</TableCell>
                  <TableCell align="right">{FormatAmount(row.invoiceWorkedOnFull)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
            </CardContent>
          </Collapse>
        </Card>
      )}
        </div>
    );
};

export default InvoiceProcessingdays;
